(function ($, window, Drupal) {

    Drupal.behaviors.coursesJumps = {
        attach: function (context, settings) {
            $('select.courses-jumps', context).on('change', function() {
                window.location.href = this.value;
            });

            $('.courses-list--region-links select option[value="/courses"]', context).text("Region");
            $('.courses-list--prefecture-links select option[value="/courses"]', context).text("Prefecture");

            $('.range-list--region-links select option[value="/courses"]', context).text("Region");
            $('.range-list--prefecture-links select option[value="/courses"]', context).text("Prefecture");
        }
    };

})(jQuery, window, Drupal);